<div *ngIf="name == 'fill-mask'">
    <app-fill-mask-svg></app-fill-mask-svg>
</div>
<div *ngIf="name == 'question-answering'">
    <app-question-answering-svg></app-question-answering-svg>
</div>
<div *ngIf="name == 'summary'">
    <app-summary-svg></app-summary-svg>
</div>
<div *ngIf="name == 'table-qna'">
    <app-table-qna-svg></app-table-qna-svg>
</div>
<div *ngIf="name == 'text-classification'">
    <app-text-classification-svg></app-text-classification-svg>
</div>
<div *ngIf="name == 'text-generation'">
    <app-text-generation-svg></app-text-generation-svg>
</div>
<div *ngIf="name == 'text2tex-generation'">
    <app-text2text-generation-svg></app-text2text-generation-svg>
</div>
<div *ngIf="name == 'token-classification'">
    <app-token-classification-svg></app-token-classification-svg>
</div>
<div *ngIf="name == 'translation'">
    <app-translation-svg></app-translation-svg>
</div>
<div *ngIf="name == 'zero-shot-class'">
    <app-zero-shot-class-svg></app-zero-shot-class-svg>
</div>
<div *ngIf="name == 'img-segmentation'">
    <app-img-segmentation-svg></app-img-segmentation-svg>
</div>
